export default __webpack_public_path__ + "media/images/loop5-c085893b3ae5f265273f5105aa6be531.png";